<template>
    <span v-if="isAutoAudit">
        <img v-if="mode == 1" style="width:20px;height:20px;" src="@/assets/images/auto.png" alt="">
        <el-button v-else-if="mode == 2" type="primary" class="tag" round>
            <img style="width:16px;height:16px;vertical-align: sub;margin-right: 6px;" src="@/assets/images/auto-2.png" alt="">自动报备
        </el-button>
    </span>
</template>

<script>
export default {
    name: 'DsAutoAudit',
    props: {
        isAutoAudit: {
            type: Boolean,
            default: false
        },
        mode: {
            type: [String, Number],
            default: 1
        }
    },
    data() {
        return {
        };
    },
    methods: {

    }
};
</script>

<style lang="scss" scoped>
.tag {
    padding: 4px 8px;
    background: linear-gradient(90deg, #4DD98A 0%, #4DD9CB 100%);
    color: #fff;
    font-size: 13px;
    border: none;
}
</style>
